import { Pipe, PipeTransform } from '@angular/core';
import { FixedPipe } from './fixedPipe';
import { CurrencyPipe } from '@angular/common';

@Pipe({
    name: 'fixedCurrency'
})
export class FixedCurrencyPipe implements PipeTransform {
    private fixedPipe: FixedPipe = new FixedPipe();
    private currencyPipe: CurrencyPipe = new CurrencyPipe('en-US');
    public transform(value: any): any {
        const fixed = this.fixedPipe.transform(value);
        return this.currencyPipe.transform(fixed);
    }
}
